import type { ElementType } from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { NavLink } from "react-router-dom";
export interface NavigationItem {
  to: string;
  end?: boolean;
  Icon: ElementType;
  text: string;
}
export default function CustomListItem({
  to,
  end,
  open,
  Icon,
  text,
  onNavigate,
}: NavigationItem & { open: boolean; onNavigate?: () => void }) {
  return (
    <Tooltip title={text} placement="right">
      <ListItemButton
        component={NavLink}
        to={to}
        end={end}
        onClick={onNavigate}
        aria-label={text}
        className="customListItem"
        sx={{
          minHeight: 48,
          justifyContent: open ? "initial" : "center",
          px: 2.5,
          color: "inherit",
          "&.active": { bgcolor: "rgba(255,255,255,0.12)" },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            color: "rgba(255,255,255,0.9)",
            mr: open ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          <Icon />
        </ListItemIcon>
        <ListItemText
          primary={text}
          sx={{
            opacity: open ? 1 : 0,
            minWidth: 0,
            "& .MuiListItemText-primary": {
              fontSize: 14,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          }}
        />
      </ListItemButton>
    </Tooltip>
  );
}
